export default __webpack_public_path__ + "static/media/made-for-teams.4264c3b1.png";